import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';
import { getOpxHostApi } from 'owa-opx';
import { isThemeModeSetByHostApp } from './isThemeModeSetByHostApp';
import { loadInitialTheme } from './loadInitialTheme';
import { ThemeMode } from '../schema/ThemeMode';

/**
 * Initial load of theme from Opx host
 */
export const loadInitialOpxTheme = async (): Promise<void> => {
    const opxHostApi = getOpxHostApi();

    let isDarkTheme: boolean;
    let themeMode: ThemeMode;
    if (isThemeModeSetByHostApp()) {
        const miniHostAppDetail = getMiniHostAppDetail();
        isDarkTheme = miniHostAppDetail.isDarkTheme;
        themeMode = miniHostAppDetail.themeMode;
    } else {
        isDarkTheme = await opxHostApi.isDarkTheme();
        themeMode = isDarkTheme ? ThemeMode.Dark : ThemeMode.Light;
    }

    const opxPalette = await opxHostApi.getOpxPalette(isDarkTheme);
    loadInitialTheme(themeMode, opxPalette);
};
